import { createCrudSlice } from '../../../../data/store/create-crud-slice';
import Person from './Person';

const peopleSlice = createCrudSlice<Person>('people');
export const { removeItem, createItem, updateItem, setItems } = peopleSlice.actions;

export default peopleSlice;